module.exports = __webpack_public_path__ + "static/media/29ADMSPC22.385f36c7.jpg";